import React from "react";
import { SiVisa } from "react-icons/si";

export default function AcceptedCardBrands({ selectedBrand = "" }) {
  const badge = (brand) => ({
    display: "inline-flex", alignItems: "center", justifyContent: "center",
    width: 62, height: 38, flexShrink: 0, boxSizing: "border-box",
    border: `1px solid ${selectedBrand === brand ? "#0d9488" : "#e2e8f0"}`,
    borderRadius: 7, background: "#fff", padding: 6,
  });
  return (
    <div aria-label="Tarjetas aceptadas" style={{ display: "flex", gap: 8, alignItems: "center", flexShrink: 0 }}>
      <span style={badge("visa")}>
        <SiVisa role="img" aria-label="Visa" style={{ width: 44, height: 26, color: "#1434CB" }} />
      </span>
      <span style={badge("mastercard")}>
        <svg role="img" aria-label="Mastercard" viewBox="0 0 48 30" style={{ width: 44, height: 28 }}>
          <circle cx="18" cy="15" r="14" fill="#EB001B" />
          <circle cx="30" cy="15" r="14" fill="#F79E1B" />
          <path d="M24 2.35a14 14 0 0 1 0 25.3 14 14 0 0 1 0-25.3Z" fill="#FF5F00" />
        </svg>
      </span>
    </div>
  );
}
